module.exports = {
    DOMAIN_NAME: 'https://myiotpro.in/wallmachinelogapp/public',
    // DOMAIN_NAME: 'http://192.168.1.12/wallmachinelogapp/public',
    ADD_CLIENT: '/addclient',
    GET_CLIENTS: '/getclients',
    ADD_MACHINE: '/addmachine',
    GET_MACHINES: '/getmachines',
    GET_REPORT_ADMIN: '/getreportforadmin',
    ADMIN_LOGIN: '/adminlogin',
    UPDATE_JACKPOT_MACHINE: '/updatejackmachinestatus',
    UPDATE_JACKPOT_VALUES: '/updatejackpotvalue'
}